// Values mirror the AuditUnit `key` and `run_and_drive` enumerations in DFP
export const unitKeyEnum = {
  "1": "Yes",
  "2": "No",
  "3": "Yes, but it does not work",
}

export const runAndDriveEnum = {
  "1": "Yes",
  "2": "No",
  "3": "Yes, with a jump",
}

// Answers offered in the condition report form; the remaining enum values are display-only
export const conditionReportAnswerOptions = {
  "1": "Yes",
  "2": "No",
}
